import { useQuery as useApolloQuery } from '@apollo/client';
import { useErrorHandler } from '../useErrorHandler/useErrorHandler';

export const useQuery = (query, options = {}) => {
  const handleError = useErrorHandler();
  return useApolloQuery(query, handleError(options));
};
